import { PERMISSIONS } from '../../constants'
import list from './DispatchMessageList'
import show from './DispatchMessageShow'

export default {
  show,
  list,
  name: 'chains/chainId/dispatch-messages',
  permissions: [PERMISSIONS.DISPATCH_MESSAGE]
}